import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import SchoolCourseDetails from './section-components/school-courses-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const SchoolCourses = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Coaching For School Students | 9th,10th,11th,12th classes| MIET</title>
            <meta name="description" content="MIET Chennai provides coaching for school students. We have the best faculty, who have experience in the respective fields. Contact us for more information." />
        </Helmet>
        <PageHeader headertitle="School Courses"  />
        <SchoolCourseDetails />
        <Footer />
    </div>
}

export default SchoolCourses